import { jobDetailsStateForJobIdSelector } from '../../reducers/job-selectors';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import Job from '../../api/job-api-client';

export const loadJobDetails = (jobId: number) =>
  createGenericDispatcher({
    name: 'LOAD_JOB_DETAILS',
    loadFunction: () => new Job(jobId).loadJobDetails(),
    args: { jobId },
    shouldExecuteSelector: (state: any) => jobDetailsStateForJobIdSelector(state, jobId),
  });
